import { Grid } from '@material-ui/core'
import Wysiwyg from 'Components/Wysiwyg'
import ApiRequest from 'EurestoApi/ApiRequest'
import User from 'EurestoClass/User'
import DataComponent from 'EurestoComponents/DataComponents'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import project from 'EurestoConfig/project.config'
import Constants from 'EurestoFonction/Constants'
import moment from 'moment'
import React, { useState } from 'react'
import ApiHistorique from '../../../Api/Page/Recherche'
import Sellsy from '../../../Configuration/Component/Interface/Sellsy'


export default props => {

  const [motifId, setMotifId] = useState(props.motif_id)
  const [commentaire, setCommentaire] = useState(props.commentaire)

  const handleUnarchive = async () => {
    const r = await ApiRequest(project.api + 'crm', {
      action: 'unarchive',
      requete: 'contact',
      id: props.id,
      archive_id: props.archive_id
    })
    props.onChangeArchive(false)
  }

  const handleArchive = async () => {
    const r = await ApiRequest(project.api + 'crm', {
      action: 'archive',
      requete: 'contact',
      id: props.id,
      motif_id: motifId,
      archive_commentaire: commentaire
    })
    props.onChangeArchive(true)
  }

  return <React.Fragment>
    {props.isConnectedToSellsy && <Sellsy showSearch
      isAllow={{}}
      title={'Documents Sellsy'}
      searchName={'document_sellsy_' + props.id + '_'}
      maxHeight={'400px'}
      defaultSearch={{
        '?contact_id': props.id,
        '?type': 'invoice'
      }} />}
    {(User.User.get().id === 2 || User.User.get().id === 8) && <ApiHistorique showSearch
      isAllow={{}}
      title={'Historique API'}
      searchName={'historique_api_' + props.id + '_'}
      maxHeight={'400px'}
      defaultSearch={{
        '?entite_id': props.id,
        '|date_creation': [moment().add(-7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      }} />}
    <EurestoDiv title={'Archiver Contact'} expandable expanded={props.archive_id} style={{
      background: 'lightcoral'
    }} buttonsLeft={[
      (!props.archive_id && {
        title: 'Archiver',
        color: EurestoColor('EurestoError'),
        className: ' EurestoError EurestoText--text',
        icon: ' ei-commun_archiver',
        cb: handleArchive,
      } || {
        title: 'Désarchiver',
        className: 'EurestoSecondary--text',
        color: 'primary',
        icon: ' ei-commun_valider',
        cb: handleUnarchive
      })]}>
      <Grid container style={{
        margin: 0,
        padding: 0
      }} spacing={0} justify='center' alignItems='flex-start'>
        <Grid item style={{
          margin: 0,
          padding: 5
        }} sm={12} md={6}>
          <DataComponent title={EurestoI18n.t('crm:Motif Archive')} name='motif_id'
            disabled={props.archive_id} data={motifId}
            type={Constants.typeSaisie.ComboSimple}
            onChange={
              (data, name) => {
                setMotifId(data)
                props.onChange(data, name)
              }} inline
            object={Constants.donnee.type_archivage}
            module={Constants.module.CRM} />
        </Grid>
        <Grid item style={{
          margin: 0,
          padding: 5,
          height: 400
        }} sm={12} md={6}>
          <Wysiwyg
            onChange={(data, name) => {
              setCommentaire(data)
              props.onChange(data, name)
            }}
            maxHeight={'calc(100% - 28px)'}
            name='archive_commentaire'
            disabled={props.archive_id}
            value={commentaire} />
        </Grid>
      </Grid>
    </EurestoDiv>
  </React.Fragment>
}



// WEBPACK FOOTER //
// ./app/App/Module/CRM/Component/Divers/index.js